import React from 'react';
import DocumentoLegalPage from '../DocumentoLegalPage/DocumentoLegalPage';

export default function PrivacidadePage() {
  return (
    <DocumentoLegalPage
      tipo="privacidade"
      tituloPagina="Política de Privacidade"
      voltarPara="/cadastro"
    />
  );
}
